
import NativeClient from "@/client/native-client";
import { defineComponent, SetupContext, computed } from "vue";

export default defineComponent({
  name: "CommonHorizontalRecipeListItem",
  props: {
    /**
     * レシピ画像
     */
    recipeImageUrl: {
      type: String
    },
    /**
     * レシピ名
     */
    recipeLabel: {
      type: String,
      required: true
    },
    /**
     * 食材表示
     */
     isFoods: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    /**
     * ボタンが押されたことを通知する
     */
    const onClick = () => context.emit("on-click");

    /**
     * 画像読み込みエラー発生
     */
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("CommonHorizontalRecipeListItem onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("CommonHorizontalRecipeListItem onImageError target exist");
        if (props.isFoods) {
          (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png"); 
        } else {
          (event.target as HTMLImageElement).src = require("@/assets/images/noimage1.png"); 
        }
      }
    };

    const styleImage = computed(() => {
      let retValue = { objectFit: `cover` };
      if (props.isFoods) {
        retValue = { objectFit: `contain` };
      }
      return retValue;
    });

    const noImage = computed(() => {
      if (props.isFoods) {
        return require("@/assets/images/food_noimage.png");
      }
      return require("@/assets/images/noimage1.png");
    });

    return {
      onClick,
      styleImage,
      onImageError,
      noImage
    };
  }
});
